import { fetchWithCredentials, setSessionToken } from './client';
import {
  mapSessionUser,
  SapSessionApiResponse,
  SessionResult,
  ValidateResponse,
  RefreshResponse,
  OidcBootstrapData,
} from './auth.types';

export async function getOidcBootstrap(
  sapHost: string,
  redirectUri: string
): Promise<OidcBootstrapData> {
  const params = new URLSearchParams({ sapHost, redirectUri });
  const response = await fetchWithCredentials<{
    success: boolean;
    data: OidcBootstrapData;
  }>(`/api/v1/session/oidc/bootstrap?${params.toString()}`, {
    method: 'GET',
  });

  return response.data;
}

export async function createOidcSession(
  sapHost: string,
  oidc: { code: string; codeVerifier: string; redirectUri: string }
): Promise<SessionResult> {
  const response = await fetchWithCredentials<SapSessionApiResponse>('/api/v1/session/oidc', {
    method: 'POST',
    body: JSON.stringify({ sapHost, ...oidc }),
  });

  setSessionToken(response.data.token);

  return {
    sessionToken: response.data.token,
    accessToken: response.data.accessToken,
    expiresIn: response.data.expiresIn,
    user: mapSessionUser(response.data),
  };
}

export async function validateSession(): Promise<ValidateResponse> {
  return fetchWithCredentials<ValidateResponse>('/api/v1/session/validate');
}

export async function refreshToken(): Promise<RefreshResponse> {
  const response = await fetchWithCredentials<ValidateResponse>('/api/v1/session/validate');
  return {
    accessToken: response.data.accessToken,
    expiresIn: response.data.expiresIn,
    expiresAt: Date.now() + response.data.expiresIn * 1000,
  };
}

export async function logout(): Promise<void> {
  try {
    await fetchWithCredentials('/api/v1/session/logout', { method: 'POST' });
  } finally {
    setSessionToken(null);
  }
}
